var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgProtocols = function SvgProtocols(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.16,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#1F313A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#protocols_svg__clip0_1203_32429)",
    fill: "#56CCF2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.194 20.671v-.019c-.01-.23-.018-.474-.022-.745a2.544 2.544 0 00-2.395-2.492c-2.76-.154-4.894-1.054-6.718-2.832l-.015-.015a1.536 1.536 0 00-2.088 0l-.015.015c-1.824 1.778-3.959 2.678-6.718 2.832a2.543 2.543 0 00-2.395 2.492c-.004.27-.011.513-.022.745l-.001.044c-.054 2.813-.12 6.315 1.051 9.494.644 1.748 1.62 3.267 2.9 4.516 1.457 1.422 3.366 2.552 5.674 3.356a1.764 1.764 0 00.57.097 1.725 1.725 0 00.571-.097c2.305-.806 4.212-1.936 5.668-3.358 1.28-1.25 2.255-2.77 2.9-4.517 1.175-3.189 1.109-6.697 1.055-9.516zm-2.377 9.028c-1.235 3.35-3.758 5.651-7.71 7.034a.318.318 0 01-.213 0c-3.958-1.38-6.482-3.68-7.716-7.03-1.08-2.93-1.019-6.144-.965-8.98v-.016c.011-.244.019-.5.023-.78a1.13 1.13 0 011.065-1.106c1.562-.087 2.934-.389 4.194-.923 1.259-.532 2.377-1.284 3.418-2.296a.13.13 0 01.174 0c1.041 1.012 2.16 1.764 3.418 2.296 1.26.534 2.632.836 4.194.923a1.13 1.13 0 011.065 1.107c.004.282.012.537.023.779.053 2.84.113 6.056-.97 8.992z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 20.18a5.988 5.988 0 00-5.982 5.98A5.988 5.988 0 0026 32.143a5.988 5.988 0 005.98-5.981A5.988 5.988 0 0026 20.179zm0 10.553a4.578 4.578 0 01-4.573-4.572A4.578 4.578 0 0126 21.588a4.578 4.578 0 014.572 4.573A4.578 4.578 0 0126 30.733z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.718 24.303L24.94 27.08l-.754-.754a.704.704 0 00-.996.995l1.252 1.252a.701.701 0 00.996 0l3.276-3.276a.704.704 0 00-.996-.995z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "protocols_svg__clip0_1203_32429"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14 14.16)",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgProtocols;